<template>
  <d2-container>
    <template slot="header">
      <el-form
        :inline="true"
        :model="searchForm"
        ref="searchForm"
        size="mini"
        style="margin-bottom: -18px;"
      >
        <el-form-item
        >
          <el-input
                  v-model="searchForm.batch_no"
                  placeholder="批次"
                  style="width: 100px;"
          />
        </el-form-item>
        <el-form-item
        >
        <el-date-picker
                v-model="dateRange"
                :picker-options="pickerOptions"
                type="daterange"
                range-separator="~"
                start-placeholder="开始日期"
                end-placeholder="结束日期"    width="150">

        </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="handleSearchFormSubmit"
          >
            <d2-icon name="search" /> 查询
          </el-button>
        </el-form-item>

        <el-form-item>
          <el-button @click="handleSearchFormReset">
            <d2-icon name="refresh" /> 重置
          </el-button>
        </el-form-item>
      </el-form>
    </template>
    <el-button
            type="primary"
            size="mini"
            icon="el-icon-circle-plus"
            @click="openViewForm"
    >
      批量生成
    </el-button>
    <el-table
      :data="tableData"
      v-loading="loading"
      size="small"
      stripe
      highlight-current-row
      style="width: 100%;"
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange"
    >

      <el-table-column label="序号" type="index" align="center" show-overflow-tooltip width="50px">
      </el-table-column>

      <el-table-column
        label="批次"
      >
        <template slot-scope="scope">
          {{scope.row.batch_no}}
        </template>
      </el-table-column>
      <el-table-column
        label="生成时间"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.generation_times}}
        </template>
      </el-table-column>
      <el-table-column
        label="生成数量"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.generation_num}}
        </template>
      </el-table-column>

      <el-table-column
              label="操作代理"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.agentname}}
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        align="center"
        width="200"
      >
        <template slot-scope="scope">
          <el-button type="primary" plain  size="mini"    @click="down(scope.row)">批量下载</el-button>
          <el-button type="primary" plain  size="mini"   @click="del(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>

    </el-table>
    <template slot="footer">
      <el-pagination
        :current-page="page.current"
        :page-size="page.size"
        :total="page.total"
        :page-sizes="[1,10,50,100, 200, 300, 400]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: -10px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </template>
    <view-form
            :agent="agent"
            v-model="viewFormVisible"
            @submit="getTableData"
    />
  </d2-container>
</template>
<script>
    import * as agentService from "@/api/sys/agent";
    import util from '@/libs/util.js'
    import viewForm from "./viewForm"
export default {
  name: "paymentcodePage",
  components: {viewForm},
  data() {
    return {
      searchForm: {
      },
      loading: false,
        agent: {},
        editFormVisible: false,
        viewFormVisible: false,
      tableData: [],
        dateRange: [],
        pickerOptions:{},
      multipleSelection: [],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      sort: {
        prop: "",
        order: ""
      }
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
      down(agent){
          window.open("https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/"+agent.url)
      },
      dateConversion(value) {
          if (value != null && value != "") {
              var d = new Date(value);
              //  var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
              var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
              console.info("===========date=========" + date);
              return date;
          }else{
              return "";
          }
      },
    getTableData() {
      let query = {
        pageIndex: this.page.current,
        pageSize: this.page.size,
        sortBy: this.sort.prop,
          agentid: util.cookies.get('agentid'),
          start_time:this.dateConversion(this.dateRange[0]),
          end_time:this.dateConversion(this.dateRange[1]),
          dl_type: util.cookies.get('dl_type'),
          xt_id: util.cookies.get('xt_id'),
        descending: this.sort.order === "descending",
        filter: this.searchForm
      };
        agentService.getPaymentcodePagedlist(query).then(data => {
        this.tableData = data.rows;
        this.page.total = data.totalCount;
      });
    },
    handleSearchFormSubmit() {
      this.getTableData();
    },
    handleSearchFormReset() {
      this.$refs.searchForm.resetFields();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSortChange(val) {
      this.sort.prop = val.prop;
      this.sort.order = val.order;
      this.getTableData();
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.page.current = val;
      this.getTableData();
    },
    openEditForm(agent) {
      this.agent = agent;
      this.editFormVisible = true;
        this.viewFormVisible = false;
    },
      openViewForm() {
          this.agent = {};
          this.editFormVisible = false;
          this.viewFormVisible = true;
      },
    del(id) {
      this.$confirm("确认删除？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消"
      }).then(() => {
          agentService.delPaymentcode({id:id}).then(() => {
          this.getTableData();
        });
      });
    }
  }
};
</script>
